import { render, staticRenderFns } from "./nijian.vue?vue&type=template&id=139a9383&"
import script from "./nijian.vue?vue&type=script&lang=js&"
export * from "./nijian.vue?vue&type=script&lang=js&"
import style0 from "./nijian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports